import Tabs from 'infrastructure/js/components/Tabs/tabs';
import Tab from 'react-bootstrap/Tab';
import { Route, Switch } from 'react-router-dom';
import useLabels from 'infrastructure/js/hooks/useLabels';
import useTabsWithUrl from 'infrastructure/js/hooks/useTabsWithUrl';
import KitTypesViewContainer from '../../../../containers/Administration/MatSettingsPage/kitTypesViewContainer';
import FullScreenTabsSeparator from '../../../Common/FullScreenTabsSeparator/fullScreenTabsSeparator';
import ArchivedKitTypesViewContainer from '../../../../containers/Administration/MatSettingsPage/archivedKitTypesViewContainer';
import KitTypeFormWrapper from '../KitTypesView/kitTypeFormWrapper';

import './KitTypesPage.scss';

const tabKeys = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
};

const KitTypesPage = (props) => {

  const labels = useLabels('mat.administration.matsettings.kittypes.view.');
  const tabsLabels = useLabels('mat.common.tabs.');

  const { getTabKeyFromURL, setTabKeyInURL } = useTabsWithUrl(
    '/Administration/matSettings/kits/kitTypes',
    Object.values(tabKeys),
    'active',
    'tabId'
  );

  const handleTabClick = (tabKey) => {
    setTabKeyInURL(tabKey);
  };

  return (
    <div className="kit-types-page">
      <Switch>
        <Route key='kitTypesFormKey' exact
               path={`${props.match.path}/:tabId?/kitTypeForm/:kitTypeId?/:mode?`}
               component={KitTypeFormWrapper}
        >
        </Route>

        <Route key='kitTypesFormKey' path={props.match.path}>
          <div className="title">{labels.get('title')}</div>
          <FullScreenTabsSeparator/>

          <Tabs id="kit-types-tabs" tabType="page" activeKey={getTabKeyFromURL()} onSelect={handleTabClick}
                mountOnlyActiveTab={true}>
            <Tab title={tabsLabels.get('active')} eventKey={tabKeys.ACTIVE}>
              <KitTypesViewContainer match={props.match} history={props.history}/>
            </Tab>
            <Tab title={tabsLabels.get('archived')} eventKey={tabKeys.ARCHIVED}>
              <ArchivedKitTypesViewContainer match={props.match} history={props.history}/>
            </Tab>
          </Tabs>

        </Route>
      </Switch>
    </div>
  );
};

export default KitTypesPage;
